<template>
  <div class="hwit hwit--hover homework__item" @click="$emit('onSelectHW', item)">
    <div class="hwit__top">
      <div class="homework__date"><span class="ico-calendar" uk-tooltip="Дата создания"></span>
        <span>{{ reDate(item.created_at) }}</span></div>

      <div class="homework__date hwit__dates" v-if="item.string_dates">
        <span class="ico-calendar" uk-tooltip="Даты домашнего задания"></span>
        <span>{{ item.string_dates }}</span>
      </div>
    </div>

    <!--Настройки-->
    <div class="homework__content">
      <div class="hwit__wrap">
        <div class="homework__title">
          Настройки тренажера / Описание:


          <small>
            <span class="uk-badge" uk-tooltip="Количество повторов" v-if="item.trainer_id">{{ item.qnt }}</span>

            <span uk-tooltip="Направление" class="uk-badge" v-if="typeof item.params.direct !== 'undefined'">{{ item.params.direct ? 'Прямое' : 'Обратное' }}</span>

            <span @click="showAlert(trainer[0])" class="uk-badge" style="cursor: pointer" v-if="typeof item.params.desc !== 'undefined'">Описание</span>

            <span uk-tooltip="Размер поля" class="uk-badge" v-if="item.params.size">{{ item.params.size }} x {{ item.params.size }}</span>

            <span uk-tooltip="Режим" class="uk-badge" v-if="item.params.mode && !item.params.selected_mode">{{ item.params.mode }}</span>
            <span uk-tooltip="Режим" class="uk-badge" v-if="item.params.selected_mode">{{ item.params.selected_mode.text }}</span>

            <span uk-tooltip="Название текста" class="uk-badge" v-if="item.params.text_title">{{ item.params.text_title }}</span>

            <span uk-tooltip="Скорость" class="uk-badge" v-if="item.params.speed && item.trainer.component !== 'columns'">
									<i v-if="item.trainer_id !== 5">{{ isInt(item.params.speed) }}</i>
									<i v-else-if="item.trainer_id === 5">{{ item.params.mode == 'train' ? 'Нет' : isInt(item.params.speed) }}</i>
								</span>
          </small>

        </div>
        <div class="hwit__right">
          <div class="hwit__students">
            <small>Ученики:</small>
            <span>{{ users }}</span>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import moment from "moment";
import swal from "sweetalert";

export default {
  name: "hw-arc-item",
  data() {
    return {}
  },
  props: {
    item: ''
  },
  computed: {
    users(){
      let arc = [];
      _.forEach(this.item.students, function (e) {
        arc.push(e.name);
      });
      arc = _.uniq(arc);
      return arc.join(', ');
    }
  },
  methods: {
    reDate(date) {
      if (date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY');
      }
    },
    /** Возвращаем дробное число */
    isInt(val) {
      if (Number.isInteger(val)) {
        return val + '.0';
      } else {
        return val;
      }
    },
    /** Split */
    split(str, razd) {
      return str.split(razd);
    },
  }
}
</script>